import { useLocation } from '@ecomm/framework/useLocation'

const SUPPORTED_ROUTES = new Set([
  '/cart',
  '/cart/checkout',
  '/payment-page',
  '/alarm-sensors'
])

/**
 * Hook that determines if live chat should be rendered on the user's current route. Currently
 * only returns true if the user is on one of the following pages:
 * - /cart
 * - /checkout
 * - /payment-page
 * - /alarm-sensors
 */
export function useIsLiveChatSupportedForRoute() {
  const location = useLocation()

  return SUPPORTED_ROUTES.has(location.pathname)
}
